import PropTypes from 'prop-types';
import React from 'react';
import ManageBidRouteItems from  './ManageBidRouteItems';
import HotelScroller from './HotelScroller';
import HotelSelector from './HotelSelector';
import { findById } from '../../../core/utils';

class ManageBidRoutesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
    };
    this.next = this.next.bind(this);
    this.prev = this.prev.bind(this);
    this.renderInstructionText = this.renderInstructionText.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.selectedRoute !== nextProps.selectedRoute) {
      if (nextProps.selectedRoute === null) {
        this.setState({
          current: 0,
        });
        return;
      }
      const stops = this.props.routes;
      const idx = stops.findIndex(findById, nextProps.selectedRoute.id);
      if (idx !== -1) {
        this.setState({
          current: idx,
        });
      }
    }
  }

  prev() {
    const { current } = this.state;
    if (current === 0) {
      this.setState({
        current: this.props.routes.length - 1,
      });
    } else {
      this.setState({
        current: current - 1,
      });
    }
  }
  next() {
    const { current } = this.state;
    if (current >= this.props.routes.length - 1) {
      this.setState({
        current: 0,
      });
    } else {
      this.setState({
        current: current + 1,
      });
    }
  }
  renderInstructionText() {
    if (!this.props.selectedEvent) {
      return (
        <div style={{padding: '0px 0px 30px 275px'}}>
          <br/>
          <h3>Select a city to view bids.</h3>
        </div>
      );
    }
    return(
      <span> </span>
    )
    
  }
  render() {
    const routeId = this.props.routeId;
    const eventId = this.props.selectedRoute ? this.props.selectedRoute.id : 0;
    const routes = [];
    const stops = this.props.routes;
    const remaining = this.props.routes.length - this.state.current;
    const len = remaining > this.props.width ? this.props.width : remaining;

    let index = this.state.current + 4;
    let endVal = stops[index]?stops[index]:stops[this.props.routes.length -1];
    const dates = { start: stops[this.state.current], end:endVal};

    for (let i = this.state.current; i < this.state.current + len; i++) {


      routes.push(
        <ManageBidRouteItems
          route={stops[i]}
          key={stops[i].id}
          selected={eventId == stops[i].id}
          selectRoute={this.props.selectRoute}
        />
      );
    }

    return (
      <div className="content event-block">
      {this.renderInstructionText()}
        <div className="dateblock">
          <HotelScroller
            next={this.next}
            current={this.state.current}
            end={this.props.routes.length}
            prev={this.prev}
            dates={dates}
          />
          <HotelSelector routes={stops} current={eventId} selectRoute={this.props.selectRoute} />
        </div>
        <div className="eventblock">{routes}</div>
      </div>
    );
  }
}

ManageBidRoutesList.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedRoute: PropTypes.object,
  selectRoute: PropTypes.func.isRequired,
  width: PropTypes.number,
};

ManageBidRoutesList.defaultProps = {
  routes: [],
  selectedRoute: null,
  width: 5,
};

export default ManageBidRoutesList;



// WEBPACK FOOTER //
// src/routes/tours/components/ManageBidRoutesList.js